import { Circle as CircleStyle, Fill, Icon, Stroke, Style, Text } from "ol/style";
import { SelectedStatus, FeatureType, GamePointStatus } from "../enums";

// Game
import CheckPoint_DEF from "../../img/icons/game/kontrolpunkts_unselected_default.png";
import CheckPoint_DEF_CLICKED from "../../img/icons/game/kontrolpunkts_selected_default.png";
import CheckPoint_COMPLETED from "../../img/icons/game/kontrolpunkts_unselected_iziets.png";
import CheckPoint_COMPLETED_CLICKED from "../../img/icons/game/kontrolpunkts_selected_iziets.png";

import CheckPoint_APPROACHED_DEF from "../../img/icons/game/kontrolpunkts_approached_default.png";
import CheckPoint_APPROACHED_CLICKED from "../../img/icons/game/kontrolpunkts_approached_clicked.png";

import GamePoint_DEF from "../../img/icons/game/speles_punts_unselected_default.png";
import GamePoint_DEF_CLICKED from "../../img/icons/game/speles_punkts_selected_default.png";
import GamePoint_STARTED from "../../img/icons/game/speles_punts_unselected_uzsakts.png";
import GamePoint_STARTED_CLICKED from "../../img/icons/game/speles_punkts_selected_uzsakts.png";
import GamePoint_COMPLETED from "../../img/icons/game/speles_punts_unselected_pabeigts.png";
import GamePoint_COMPLETED_CLICKED from "../../img/icons/game/speles_punkts_selected_pabeigts.png";

const scaleFactor = 0.5;
const gameBaseColor = "#34AFE7";

const images: Record<
    FeatureType.GameMainPoint | FeatureType.GameCheckPoint,
    Record<GamePointStatus, Record<SelectedStatus, string>>
> = {
    [FeatureType.GameMainPoint]: {
        [GamePointStatus.Default]: {
            [SelectedStatus.Default]: GamePoint_DEF,
            [SelectedStatus.Selected]: GamePoint_DEF_CLICKED
        },
        [GamePointStatus.Started]: {
            [SelectedStatus.Default]: GamePoint_STARTED,
            [SelectedStatus.Selected]: GamePoint_STARTED_CLICKED
        },
        [GamePointStatus.Completed]: {
            [SelectedStatus.Default]: GamePoint_COMPLETED,
            [SelectedStatus.Selected]: GamePoint_COMPLETED_CLICKED
        }
    },
    [FeatureType.GameCheckPoint]: {
        [GamePointStatus.Default]: {
            [SelectedStatus.Default]: CheckPoint_DEF,
            [SelectedStatus.Selected]: CheckPoint_DEF_CLICKED
        },
        [GamePointStatus.Started]: {
            [SelectedStatus.Default]: CheckPoint_DEF, // Need correct icons
            [SelectedStatus.Selected]: CheckPoint_DEF_CLICKED // Need correct icons
        },
        [GamePointStatus.Completed]: {
            [SelectedStatus.Default]: CheckPoint_COMPLETED,
            [SelectedStatus.Selected]: CheckPoint_COMPLETED_CLICKED
        }
    }
};

export const getGameSymbol = (
    featureType: FeatureType,
    gamePointStatus?: GamePointStatus | GamePointStatus.Default,
    gameSelected?: 0 | 1,
    selectedStatus?: SelectedStatus | SelectedStatus.Default,
    hidden?: boolean,
    approached?: boolean
): Style => {
    if (featureType === FeatureType.GameMainPoint) {
        if (hidden) {
            return new Style({});
        }
        return new Style({
            image: new Icon({
                src: images[featureType][gamePointStatus][selectedStatus],
                scale: scaleFactor
            })
        });
    } else if (featureType === FeatureType.GameCheckPoint) {
        if (!gameSelected) {
            return new Style({});
        }
        if (approached) {
            return new Style({
                image: new Icon({
                    src: selectedStatus ? CheckPoint_APPROACHED_CLICKED : CheckPoint_APPROACHED_DEF,
                    scale: scaleFactor
                })
            });
        }
        return new Style({
            image: new Icon({
                src: images[featureType][gamePointStatus][selectedStatus],
                scale: scaleFactor
            })
        });
    } else if (featureType === FeatureType.GameTrack) {
        return selectedStatus === SelectedStatus.Selected
            ? new Style({
                  stroke: new Stroke({
                      color: gameBaseColor,
                      width: 3
                  })
              })
            : new Style({});
    }
};
